// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-legend-container-ydeRD {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.chart-legend-item-Pj5rf {
  display: flex;
  align-items: center;
  gap: 4px;
  transform: translateY(12px);
}

.chart-legend-dot-Sxh0n {
  width: 8px;
  height: 8px;
  border-radius: 4px;
}

.chart-legend-label-vtASw {
  color: var(--color-neutral-700);
  font-size: var(--text-xs);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/chart-legend/chart-legend.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transform: translateY(12px);\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n}\n\n.label {\n  color: var(--color-neutral-700);\n  font-size: var(--text-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `chart-legend-container-ydeRD`,
	"item": `chart-legend-item-Pj5rf`,
	"dot": `chart-legend-dot-Sxh0n`,
	"label": `chart-legend-label-vtASw`
};
export default ___CSS_LOADER_EXPORT___;
